export default "__VITE_ASSET__DIU0vsXI__"